import { z } from 'zod';
export const STAFF_ALERT_SEVERITIES = ['info', 'warning', 'critical'];
export const STAFF_ALERT_KINDS = ['critical_result', 'consult_request', 'order_event', 'task_overdue'];
export const STAFF_ALERT_REF_TYPES = ['admission', 'admission_investigations', 'admission_orders', 'admission_tasks', 'referral'];
export const STAFF_ALERT_SNOOZE_MINUTES = [5, 15, 30, 60];
export const STAFF_ALERT_EVENT = 'staff-alert';
export const STAFF_DUTY_EVENT = 'staff-duty';
export const STAFF_ALERT_PAGE_SIZE = 30;
export const STAFF_ALERT_MAX_AUDIENCE = 200;
export const STAFF_ALERT_TRAY_VISIBLE = 4;
export const STAFF_ALERT_MESSAGE_KEYS = [
    'staff_alert.critical_lab',
    'staff_alert.critical_radiology',
    'staff_alert.consult_request',
    'staff_alert.order_created',
    'staff_alert.order_stopped',
    'staff_alert.order_held',
    'staff_alert.tasks_overdue',
];
export const STAFF_ALERT_LIFETIME_HOURS = {
    info: 24,
    warning: 72,
    critical: 168,
};
export const STAFF_ALERT_SMS_DELAY_DEFAULT = 15;
export const STAFF_ALERT_SMS_DELAY_MIN = 5;
export const STAFF_ALERT_SMS_DELAY_MAX = 240;
export function resolveStaffAlertSettings(raw) {
    const delay = raw?.staffAlertSmsDelayMinutes;
    const validDelay = typeof delay === 'number' && Number.isInteger(delay) && delay >= STAFF_ALERT_SMS_DELAY_MIN && delay <= STAFF_ALERT_SMS_DELAY_MAX;
    return {
        smsEscalation: raw?.staffAlertSmsEscalation === true,
        smsDelayMinutes: validDelay ? delay : STAFF_ALERT_SMS_DELAY_DEFAULT,
    };
}
export const staffAlertSnoozeSchema = z.object({
    minutes: z.union([z.literal(5), z.literal(15), z.literal(30), z.literal(60)]),
});
export const staffAlertFeedQuerySchema = z.object({
    cursor: z.string().uuid().optional(),
});
export function wardTasksPath(wardId) {
    return `/ipd/wards/${encodeURIComponent(wardId)}/tasks`;
}
export function isStaffAlertRefType(value) {
    return typeof value === 'string' && STAFF_ALERT_REF_TYPES.includes(value);
}
export function staffAlertPath(ref) {
    if (!ref)
        return null;
    const id = encodeURIComponent(ref.id);
    switch (ref.type) {
        case 'admission':
            return `/ipd/admissions/${id}`;
        case 'admission_investigations':
            return `/ipd/admissions/${id}/emr?section=investigations`;
        case 'admission_orders':
            return `/ipd/admissions/${id}/emr?section=orders`;
        case 'admission_tasks':
            return `/ipd/admissions/${id}/emr?section=task-chart`;
        case 'referral':
            return '/queue';
        default:
            return null;
    }
}
//# sourceMappingURL=staff-alerts.js.map